import { Component, Input } from '@angular/core';

import { BtnBaseComponent } from '../../../../../app/shared/components/btns/btn-base/btn-base.component';


@Component({
  selector: 'app-btn-create',
  template: `
    <button type="button" class="btn btn-{{theme}}" [disabled]="disabled"
      appBtnSpinner [appBtnSpinnerLoading]="status && status.loading"
      (click)="onButtonClick($event)">
      <i class="fa fa-edit"></i> {{'label.general.create' | translate}} {{type | translate}}
    </button>
  `
})
export class BtnCreateComponent extends BtnBaseComponent {

  @Input() type: string;

  constructor() {
    super();
  }
}
